import React from 'react';
import FormSection from '../../../../components/atom/FormSection';
import FormikInput from '../../../../components/atom/FormikInput';
import FormikPhoneInput from '../../../../components/atom/FormikPhoneInput';

export default function ClientEditContacts() {
    return (
        <FormSection title="Contact information">
            <FormikInput name="contact_name" label="Contact name" xs={12} sm={12} />
            <FormikPhoneInput name="contact_phone_office" label="Phone office" />
            <FormikInput name="contact_email_office" label="Email office" />
            <FormikPhoneInput name="contact_phone_reservation" label="Phone reservation" />
            <FormikInput name="contact_email_reservation" label="Email reservation" />
            <FormikPhoneInput name="contact_phone_customer" label="Phone customer support" />
            <FormikInput name="contact_email_customer" label="Email customer support" />
            <FormikInput
                multiline
                name="office_information"
                label="Office Information"
                xs={12}
                sm={12}
            />
            <FormikInput
                multiline
                name="billing_information"
                label="Billing Information"
                xs={12}
                sm={12}
            />
            <FormikInput multiline name="billing_terms" label="Billing Terms" xs={12} sm={12} />
        </FormSection>
    );
}
